/**
 * /pay — custom-domain entry. When a business points its own domain (e.g. pay.example.com) at the
 * BEAM pay host, the root resolves the host to that business's slug and forwards to /pay/<slug>.
 * On the canonical host (or an unmatched host) it shows a short "use your business's pay link"
 * message. Web-only surface (anonymous customers). NEVER imports @smartbox/*.
 */
import { useEffect, useState } from 'react';
import { ActivityIndicator, Platform, StyleSheet, View } from 'react-native';
import { useRouter } from 'expo-router';
import { resolveHostSlug } from '../../../src/api/publicPay';
import { Screen, Text, Card } from '../../../src/components/ui';
import { theme } from '../../../src/theme';

export default function PayIndexScreen() {
  const router = useRouter();
  const [resolving, setResolving] = useState(Platform.OS === 'web');

  useEffect(() => {
    if (Platform.OS !== 'web') {
      setResolving(false);
      return;
    }
    const host = typeof window !== 'undefined' ? window.location.host : '';
    let cancelled = false;
    resolveHostSlug(host)
      .then((slug) => {
        if (cancelled) return;
        if (slug) router.replace(`/pay/${slug}`);
        else setResolving(false);
      })
      .catch(() => {
        if (!cancelled) setResolving(false);
      });
    return () => {
      cancelled = true;
    };
  }, [router]);

  if (resolving) {
    return (
      <Screen>
        <View style={styles.center}>
          <ActivityIndicator color={theme.color.action.primary} accessibilityLabel="Loading" />
        </View>
      </Screen>
    );
  }

  return (
    <Screen scroll>
      <Text variant="title">Pay an invoice</Text>
      <Card>
        <Text variant="body" color="secondary">
          To pay an invoice, open the pay link your contractor gave you. It looks like
          getabeam.com/pay/their-business, or their own website.
        </Text>
      </Card>
    </Screen>
  );
}

const styles = StyleSheet.create({
  center: { paddingVertical: theme.spacing.lg, alignItems: 'center' },
});
